const loginForward = {

	init: function() {

		loginForward.forwardAfterAuth();

	},

	forwardAfterAuth: function() {
		let btn = document.getElementById('buttonReturnToApp');
		if (btn !== null) {
			setTimeout(function() {
				btn.click();
			}, 500);
		}
	}

};

export default loginForward;
